import React, { useState } from "react"
import { useSelector } from "react-redux"
import { updateJobServiceTransition } from "requesters/jobServiceRequester"
import {
  ADMIN,
  ASSIGN_OVERSEAS_MANAGER,
  DRAFTING_MANAGER,
  DRAFTING_3D_MANAGER,
  DRAFTING_OVERSEAS,
  DRAFTING_OVERSEAS_LEBANON,
  DRAFTING_OVERSEAS_PHILIPPINES,
  DRAFTING_OVERSEAS_ARCHICAD,
  OVERSEAS_STATES_ALLOWED,
} from "utils/constants"
import { getBaseUrl, getCurrentUser } from "../../../../reducers"
import ConfirmationModal from "../../modals/ConfirmationModal"

const OverseasDraftingAssignmentButtons = ({
  jobService,
  comment,
  inactiveOutlineVariant = "secondary",
}) => {
  const baseUrl = useSelector(getBaseUrl)
  const currentUser = useSelector(getCurrentUser)
  const currentTeamRole = currentUser.attributes.current_team_role
  const systemRole = currentUser.attributes.role

  const [overseas2D, setOverseas2D] = useState(false)
  const [overseas3dLebanon, setOverseas3dLebanon] = useState(false)
  const [overseas3dPhilippines, setOverseas3dPhilippines] = useState(false)
  const [overseas3dArchicad, setOverseas3dArchicad] = useState(false)

  const isAdmin = systemRole === ADMIN
  const isLocalDraftingManager = currentTeamRole.includes(DRAFTING_MANAGER)
    || currentTeamRole.includes(DRAFTING_3D_MANAGER)
    || isAdmin

  const {
    id,
    attributes: {
      state,
      is3D,
      jobNo,
      forProjectX,
      projectXJobNo,
      jobTitle,
    },
  } = jobService

  const btnOutline = `btn btn-outline-${inactiveOutlineVariant}`
  const btnPrimary = "btn-primary"
  const displayJobNo = forProjectX ? projectXJobNo : jobNo

  const sendToOverseas = (transition, draftingTeam = null) => {
    updateJobServiceTransition(baseUrl, id, transition, comment, null, draftingTeam)
      .then(res => {
        if (res.status === 200) {
          window.location.reload()
        }
      })
      // eslint-disable-next-line no-console
      .catch(err => console.log(err))
  }

  const overseas2dHandler = () => {
    setOverseas2D(!overseas2D)
  }

  const overseas3dLebanonHandler = () => {
    setOverseas3dLebanon(!overseas3dLebanon)
    setOverseas3dPhilippines(false)
    setOverseas3dArchicad(false)
  }

  const overseas3dPhilippinesHandler = () => {
    setOverseas3dPhilippines(!overseas3dPhilippines)
    setOverseas3dLebanon(false)
    setOverseas3dArchicad(false)
  }

  const overseas3dArchicadHandler = () => {
    setOverseas3dArchicad(!overseas3dArchicad)
    setOverseas3dLebanon(false)
    setOverseas3dPhilippines(false)
  }

  if (OVERSEAS_STATES_ALLOWED.includes(state) || !isLocalDraftingManager) {
    return null
  }

  if (is3D) {
    return (
      <div className="mr-2">
        <button className={`btn ${overseas3dLebanon ? btnPrimary : btnOutline} mt-2 mr-2`} type="button" onClick={overseas3dLebanonHandler}>Overseas Lebanon</button>
        {overseas3dLebanon && (
          <ConfirmationModal jobNo={displayJobNo} jobTitle={jobTitle} show={overseas3dLebanon} resetState={() => setOverseas3dLebanon(false)} sendTo={() => sendToOverseas(ASSIGN_OVERSEAS_MANAGER, DRAFTING_OVERSEAS_LEBANON)} messageType="Overseas Lebanon"></ConfirmationModal>
        )}

        <button className={`btn ${overseas3dPhilippines ? btnPrimary : btnOutline} mt-2 mr-2`} type="button" onClick={overseas3dPhilippinesHandler}>Overseas Philippines</button>
        {overseas3dPhilippines && (
          <ConfirmationModal jobNo={displayJobNo} jobTitle={jobTitle} show={overseas3dPhilippines} resetState={() => setOverseas3dPhilippines(false)} sendTo={() => sendToOverseas(ASSIGN_OVERSEAS_MANAGER, DRAFTING_OVERSEAS_PHILIPPINES)} messageType="Overseas Philippines"></ConfirmationModal>
        )}

        <button className={`btn ${overseas3dArchicad ? btnPrimary : btnOutline} mt-2`} type="button" onClick={overseas3dArchicadHandler}>Overseas ArchiCad</button>
        {overseas3dArchicad && (
          <ConfirmationModal jobNo={displayJobNo} jobTitle={jobTitle} show={overseas3dArchicad} resetState={() => setOverseas3dArchicad(false)} sendTo={() => sendToOverseas(ASSIGN_OVERSEAS_MANAGER, DRAFTING_OVERSEAS_ARCHICAD)} messageType="Overseas ArchiCad"></ConfirmationModal>
        )}
      </div>
    )
  }

  return (
    <div className="mr-2">
      <button className={`btn ${overseas2D ? btnPrimary : btnOutline} mt-2`} type="button" onClick={overseas2dHandler}>Overseas</button>
      {overseas2D && (
        <ConfirmationModal jobNo={displayJobNo} jobTitle={jobTitle} show={overseas2D} resetState={() => setOverseas2D(false)} sendTo={() => sendToOverseas(ASSIGN_OVERSEAS_MANAGER, DRAFTING_OVERSEAS)} messageType="Overseas"></ConfirmationModal>
      )}
    </div>
  )
}

export default OverseasDraftingAssignmentButtons
